import { Box, ButtonBase, Typography } from "@mui/material";
import { uiNeutrals } from "../../constants/uiNeutrals";

const TAB_DEALS = 0;
const TAB_FOLLOWING = 1;

/* Frosted tab pill — no drop shadow (avoids halo into safe area); edge via border */
const tabShellSx = {
  display: "flex",
  alignItems: "center",
  gap: 0.35,
  px: 0.75,
  py: 0.45,
  borderRadius: 999,
  bgcolor: uiNeutrals.frostedFill,
  backdropFilter: "blur(24px) saturate(1.08)",
  WebkitBackdropFilter: "blur(24px) saturate(1.08)",
  boxShadow:
    "0 4px 18px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.65)",
  border: "1px solid rgba(255,255,255,0.55)",
};

const DealsMainTabToggle = ({ tabValue, onTabChange }) => {
  return (
    <Box role="tablist" aria-label="Deals and Following" sx={tabShellSx}>
      <ButtonBase
        role="tab"
        disableRipple
        disableTouchRipple
        onClick={() => onTabChange(TAB_DEALS)}
        aria-selected={tabValue === TAB_DEALS}
        aria-label="Deals"
        sx={{
          borderRadius: 999,
          px: 1.35,
          py: 0.65,
          minHeight: 34,
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.85rem",
            lineHeight: 1,
            color: tabValue === TAB_DEALS ? "#2d2d2d" : "#9a9a9a",
            transition: "color 0.2s ease",
          }}
        >
          Deals
        </Typography>
      </ButtonBase>
      <ButtonBase
        role="tab"
        disableRipple
        disableTouchRipple
        onClick={() => onTabChange(TAB_FOLLOWING)}
        aria-selected={tabValue === TAB_FOLLOWING}
        aria-label="Following"
        sx={{
          borderRadius: 999,
          px: 1.35,
          py: 0.65,
          minHeight: 34,
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.85rem",
            lineHeight: 1,
            color: tabValue === TAB_FOLLOWING ? "#2d2d2d" : "#9a9a9a",
            transition: "color 0.2s ease",
          }}
        >
          Following
        </Typography>
      </ButtonBase>
    </Box>
  );
};

export default DealsMainTabToggle;
export { TAB_DEALS, TAB_FOLLOWING };
